export default {
  'zh-CN': {
    processTitle: '系统任务进程',
    download: '下载',
    downloadContent: '问题数据下载',
    del: '删除',
    allView: '查看全部',
    noData: '暂无任务进程',
    all: '全部',
    execution: '执行中',
    completed: '已完成',
    executionFailed: '执行失败',
    taskTimeout: '任务超时',
    delConfirm: '确认要删除所选任务进程吗？',
    tip: '提示',
    delSuccess: '删除成功！',
    warning: '有错误数据',
    lookup: '查看'
  },
  'en': {
    processTitle: 'System task process',
    download: 'Download',
    downloadContent: 'Download problem data ',
    del: 'Delete',
    allView: 'View all',
    noData: 'No task process yet',
    all: 'All',
    execution: 'In execution',
    completed: 'Finished',
    executionFailed: 'Execution failed',
    taskTimeout: 'Task timeout ',
    delConfirm: 'Confirm to delete the selected task process?',
    tip: 'Tips',
    delSuccess: 'Delete the success!',
    warning: 'Incorrect data',
    lookup: 'Views'
  },
  'ja': {
    processTitle: 'システムタスクプロセス',
    download: 'ダウンロード',
    downloadContent: '問題データダウンロード',
    del: '削除',
    allView: 'はすべてを見る',
    noData: 'まだタスクプロセスがありません',
    all: 'すべて',
    execution: '実行中',
    completted: 'は完了しました',
    executionFailed: '実行失敗',
    taskTimeout: 'タスクタイムアウト',
    delConfirm: 'は選択したタスクのプロセスを削除することを確認しますか？',
    tip: 'ヒント',
    delSuccess: '削除成功！',
    warning: '誤ったデータがある',
    lookup: 'チェック'
  }
}
